/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EntityWithCommentType = {
    Unit: 'Unit',
    Enumeration: 'Enumeration',
    Quantity: 'Quantity',
    Protocol: 'Protocol',
    Role: 'Role',
    QaEquipment: 'QaEquipment',
    MedicalSystem: 'MedicalSystem',
    ManualTask: 'ManualTask',
    TaskItem: 'TaskItem',
    Text: 'Text',
    JobConfiguration: 'JobConfiguration',
    JobOccurrence: 'JobOccurrence',
    EvaluationResultOrDataPoint: 'EvaluationResultOrDataPoint',
    WorkStep: 'WorkStep',
    WorkItem: 'WorkItem'
} as const;
export type EntityWithCommentType = typeof EntityWithCommentType[keyof typeof EntityWithCommentType];


export function EntityWithCommentTypeFromJSON(json: any): EntityWithCommentType {
    return EntityWithCommentTypeFromJSONTyped(json, false);
}

export function EntityWithCommentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityWithCommentType {
    return json as EntityWithCommentType;
}

export function EntityWithCommentTypeToJSON(value?: EntityWithCommentType | null): any {
    return value as any;
}

/**
 * Check if a given object implements the EntityWithCommentType interface.
 */
 export function instanceOfEntityWithCommentType(value: any): value is EntityWithCommentType {
    return Object.values(EntityWithCommentType).includes(value)
}

